/* Lumiso sepet senkronu — B modeli (24 Eyl 2026)
 *
 * Perde sepete en fazla uc satir gider (configurator):
 *   perde satiri : properties._lc_ref + properties._lc_drop (panel basina extra inc)
 *                  + properties._lc_tb = "1" (Matching tieback secildiyse)
 *   extra drop   : ayni _lc_ref, _lc_addon yok ya da "drop", urun etiketi 'lumiso-drop'
 *   tieback      : ayni _lc_ref, _lc_addon = "tieback", urun etiketi 'lumiso-tieback' (26 Eyl 2026)
 * Kural: extra drop adedi = perde adedi x _lc_drop; tieback adedi = perde adedi (panel basina 1).
 * Perde silinirse ek satirlar da silinir.
 *
 * Extra drop satirinda adet kutusu/silme dugmesi yok (sepet sablonlari), ama musteri
 * perdenin adedini degistirebilir. Bu script farki sepet sayfasi acilinca, sepet her
 * guncellendiginde ve odeme butonuna basilinca duzeltir. Tarayici araclariyla /cart
 * API'sine dogrudan yazan birini durduramaz — siparisteki "Drop" ozelligi atolyede kontrol edilir.
 */
(function () {
  "use strict";
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var running = null;

  function plan(cart) {
    var base = {}, drops = [], updates = {}, n = 0;
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._lc_ref && p._lc_drop !== undefined && p._lc_drop !== null) {
        var b = base[p._lc_ref] || (base[p._lc_ref] = { qty: 0, per: parseInt(p._lc_drop, 10) || 0,
                                                         tb: p._lc_tb === "1" });
        b.qty += it.quantity;
      } else if (p._lc_ref) {
        drops.push(it);
      }
    });
    var seen = {};
    drops.forEach(function (it) {
      var ref = it.properties._lc_ref;
      var kind = it.properties._lc_addon || "drop";     // eski sepetlerde _lc_addon yok = drop
      var b = base[ref];
      var key = ref + "|" + kind;
      var want = 0;
      if (b && !seen[key]) want = kind === "tieback" ? (b.tb ? b.qty : 0) : b.qty * b.per;
      seen[key] = true;
      if (it.quantity !== want) { updates[it.key] = want; n++; }
    });
    return n ? updates : null;
  }

  // Farki duzeltir; degisiklik olduysa true doner.
  function sync() {
    if (running) return running;
    running = fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var upd = plan(cart);
        if (!upd) return false;
        return fetch(root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: upd })
        }).then(function (r) { if (!r.ok) throw new Error("cart/update " + r.status); return true; });
      })
      .catch(function (e) { if (window.console) console.error("[lumiso-cart-sync]", e); return false; })
      .then(function (changed) { running = null; return changed; });
    return running;
  }

  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  // 1) sepet sayfasi acilinca
  function boot() {
    sync().then(function (changed) { if (changed && onCartPage()) location.reload(); });
  }

  // 2) tema sepeti guncellediginde (Dawn pub/sub varsa)
  if (typeof window.subscribe === "function" && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === "lumiso-cart-sync") return;
      sync().then(function (changed) { if (changed) location.reload(); });
    });
  }

  // 3) odemeye gecmeden once — duzeltilmeden odeme sayfasina gidilmez
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("button[name='checkout'], input[name='checkout'], a[href$='/checkout']");
    if (!btn || btn.dataset.lcSynced === "1") return;
    e.preventDefault();
    e.stopPropagation();
    sync().then(function (changed) {
      if (changed) { location.href = root + "cart"; return; }   // musteri yeni tutari gorsun
      btn.dataset.lcSynced = "1";
      btn.click();
    });
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
